module.exports = __webpack_public_path__ + "static/media/SKYBIT logo no BG.bad3a113.svg";